import { useSyncExternalStore } from "react";

import { getGuidanceSnapshot, subscribeGuidanceSnapshot } from "./guidanceStore";

export function useGuidanceSnapshot() {
    return useSyncExternalStore(subscribeGuidanceSnapshot, getGuidanceSnapshot, () => null);
}
